var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.736,
    height: 15.299,
    viewBox: "0 0 23.736 15.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 -91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.547,91H2.19A2.192,2.192,0,0,0,0,93.19v3.57c0,.014,0,.029,0,.043v7.307a2.192,2.192,0,0,0,2.19,2.19H21.547a2.192,2.192,0,0,0,2.19-2.19V93.19A2.192,2.192,0,0,0,21.547,91ZM2.19,92.391H15.081a5.155,5.155,0,0,1-2.409,3.187A11.617,11.617,0,0,1,6.327,97.3a12.452,12.452,0,0,1-4.936-.969V93.19A.8.8,0,0,1,2.19,92.391Zm20.156,11.718a.8.8,0,0,1-.8.8H2.19a.8.8,0,0,1-.8-.8V97.836a14.084,14.084,0,0,0,4.936.86,13.015,13.015,0,0,0,7.112-1.957,6.375,6.375,0,0,0,3.053-4.348h5.055a.8.8,0,0,1,.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.538,284.971a1.991,1.991,0,0,1-2.6,0,3.541,3.541,0,1,0,2.6,0Zm-2.6,2.6a.6.6,0,1,1,.6-.6A.6.6,0,0,1,321.939,287.57Zm2.6,0a.6.6,0,1,1,.6-.6A.6.6,0,0,1,324.538,287.57Z",
    transform: "translate(-305.112 -184.979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,313H50.5a.7.7,0,1,0,0,1.391H60.7a.7.7,0,1,0,0-1.391Z",
    transform: "translate(-47.494 -211.708)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.78688f97.svg";
export { ForwardRef as ReactComponent };